import { useStaticQuery, graphql } from "gatsby"

export const useSiteVideoQuery = ( handle ) => {

  const query = useStaticQuery(
    graphql`
      {
        allSiteVideo {
          edges {
            node {
              handle
              media
            }
          }
        }
      }
    `
  )

  if (handle === false) return false

  const results = query.allSiteVideo.edges.find(x => x.node.handle === handle)
  return results ? results.node : false
}


